module.exports = __webpack_public_path__ + "static/troll-a958fb1f8bcabdbd22a322642d8ef609.jpeg";